/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InvoiceDocumentFile } from '../../models/invoice-document-file';

export interface ListInvoiceDocumentFiles$Params {
  uuid: string;
}

export function listInvoiceDocumentFiles(http: HttpClient, rootUrl: string, params: ListInvoiceDocumentFiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InvoiceDocumentFile>>> {
  const rb = new RequestBuilder(rootUrl, listInvoiceDocumentFiles.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InvoiceDocumentFile>>;
    })
  );
}

listInvoiceDocumentFiles.PATH = '/invoice-document/{uuid}/files';
